import React from 'react';
import { Link } from 'react-router-dom';
import { jumpToTop } from '../utils/smoothScroll';
const legalLinks = [{
  label: 'Privacy Policy',
  to: '/privacy-policy'
}, {
  label: 'Terms of Service',
  to: '/terms-and-conditions'
}, {
  label: 'Cookie Policy',
  to: '/cookie-policy'
}, {
  label: 'Do Not Sell My Info',
  to: '/do-not-sell-my-info'
}];

/**
 * Minimal footer carrying only FindOnlineColleges.org legal links and required
 * disclosures. Used on focused landing pages where the full site footer's
 * navigation would compete with the page's single call to action.
 */
export function LegalFooter() {
  const currentYear = new Date().getFullYear();
  const scrollToTop = jumpToTop;
  return <footer className="bg-white border-t border-gray-200 py-10" data-id="element-763" data-mp="2jykro14njapl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-764" data-mp="2k170e43a3w9e">
        <nav aria-label="Legal" data-id="element-765" data-mp="2xz5agxakh6j3">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-8" data-id="element-766" data-mp="2xw9az4j2m9sj">
            {legalLinks.map(link => <li key={link.to} data-id="element-767" data-mp="21m4i77x4xtjl">
                <Link to={link.to} onClick={scrollToTop} className="text-sm text-gray-600 hover:text-gray-900 hover:underline transition-colors" data-id="element-768" data-mp="21mw2vnp726v3">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="text-xs text-gray-500 leading-relaxed space-y-3 max-w-4xl mx-auto text-center" data-id="element-769" data-mp="2gg93sztbrtij">
          <p data-id="element-770" data-mp="2pja4um3c2ufc">
            <strong className="text-gray-700" data-id="element-771" data-mp="2pis174ecddxe">Advertiser Disclosure:</strong>{' '}
            FindOnlineColleges.org is an advertising-supported site. Featured or
            trusted partner programs and all school search, finder, or match
            results are for schools that compensate us. This compensation does
            not influence our school rankings, resource guides, or other
            editorially-independent information published on this site.
          </p>
          <p data-id="element-772" data-mp="387f8ltjzqfe5">
            <strong className="text-gray-700" data-id="element-773" data-mp="194rt4iir4vr5">TCPA Disclosure:</strong> By
            submitting your information on this website, you consent to be
            contacted by our educational partners regarding their programs via
            email, telephone, or text message.
          </p>
          <p className="pt-3 text-gray-400" data-id="element-774" data-mp="1d6mvlqcf5f6i">
            &copy; {currentYear} FindOnlineColleges.org. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}